// extracted by mini-css-extract-plugin
export default {"wrapper":"Status_wrapper__-uPuZ","body":"Status_body__SIofu","icon":"Status_icon__rYBip","title":"Status_title__SS3ai","button":"Status_button__D5lp8"};